/* eslint-disable no-console */
import {useQueryClient} from '@tanstack/react-query';
import {PrintGuideParams} from 'domain/usecases';
import {useCallback} from 'react';
import {useGetPrintGuideQuery} from '../queries/useGetPrintGuideQuery';

export const usePrintGuideHandler = (params: PrintGuideParams) => {
	const {
		data: guideData,
		refetch: fetchPrintGuide,
		isFetching: isFetchingPrintGuide,
	} = useGetPrintGuideQuery(params);

	const queryClient = useQueryClient();

	const getPrintGuideUrl = useCallback(async () => {
		try {
			if (guideData?.mensagem) {
				window.open(guideData.mensagem);
				return;
			}

			const result = await fetchPrintGuide();
			const url = result.data?.mensagem;
			if (!url) throw new Error('URL não encontrada');
			window.open(url);
		} catch (error) {
			console.error('Erro ao obter URL da guia:', error);
			throw new Error('Falha ao abrir a guia de impressão.');
		}
	}, [fetchPrintGuide, params, queryClient]);

	return {
		isFetchingPrintGuide,
		getPrintGuideUrl,
	};
};
